module.exports = __webpack_public_path__ + "img/9788972976868.d944a67a.jpg";